import { types, getEnv, flow } from 'mobx-state-tree';

import Menu from '../models/Menu';
import StatefulStore from '../models/StatefulStore';

const MenuStore = StatefulStore.named('MenuStore')
  .props({
    menus: types.optional(types.array(Menu), [])
  })
  .actions((self) => {
    const setup = (menus) => {
      self.menus = menus;
      self.setLoading(false);
    };

    const loadMenus = flow(function* loadMenus() {
      self.setLoading(true);

      try {
        self.menus = yield getEnv(self).apiWrapper.request(`menus`);
      } catch (e) {
        self.setError(e);
        throw e;
      }

      self.setLoading(false);
    });

    return {
      setup,
      loadMenus
    };
  });

export default MenuStore;



// WEBPACK FOOTER //
// ./src/store/MenuStore.js